<template>
  <div class="delete-invoice">
    <i 
      v-if="detail?.invoice?.number"
      class="mc-icon icon-outline_close" 
      title="Delete Invoice"
      @click="confirm"
    />
    <McConfirmation
      :title="$t('global.alert.text.warning')"
      :ok-title="$t('global.delete')"
      :value.sync="modalConfirm"
      @handle-ok="handleDelete"
    >
      <div>{{ $t('global.confirmDelete') }} <b>{{ detail.invoice?.number }}</b> {{ $t('global.object.from') }} {{ detail.number }}</div>
    </McConfirmation>
  </div>
</template>
<script>
import * as DeliveryOrder from '@/services/rest-api/lib/delivery/delivery-order'
import McConfirmation from '@/components/McConfirmation'
import errorMessageList from '../../lib/constants/api-error-mappings'
import { Helper } from '@/mixin/helper'
export default {
  components: {
    McConfirmation
  },
  props: {
    detail: {
      type: Object
    }
  },
  data() {
    return {
      modalConfirm: false
    }
  },
  computed: {
  },
  methods: {
    confirm() {
      this.modalConfirm = true
    },
    async handleDelete() {
      const { errors } = await DeliveryOrder.deleteInvoice(this.detail.id)
      if (typeof errors === 'string') {
        Helper.methods.withErrorHandler()
        return
      }
      if (errors && typeof errors === 'object') {
        const errorMessage = Helper.methods.withErrorHandler({ errors }, errorMessageList)
        this.$mcToast.error(errorMessage)
        return
      }
      this.$mcToast.success(this.$t('delivery.invoice.warningMessage.invoiceDeleted', { deliveryOrder: this.detail.number }))
      this.$emit('additional-act')
    }
  }
}
</script>

<style lang="scss" scoped>
.delete-invoice {
  .mc-icon {
    font-size: 18px;
    margin-left: 5px;
    cursor: pointer
  }
}
</style>